
import { computed, defineComponent, PropType, toRefs, ref } from "vue";
import { UfUploadFileType } from "@/composables";
import { watch } from "vue";

export default defineComponent({
  name: "UfIdPhoto",
  props: {
    options: {
      type: Object as PropType<Approval.IdPhoto>,
      default: () => {},
      required: true
    },
    modelValue: {
      type: Array as PropType<UfUploadFileType[]>,
      default: () => []
    },
    list: {
      type: Array as PropType<Approval.SubComponents>
    },
    formData: {
      type: Object as PropType<Dictionary<any>>
    }
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const { modelValue, options, formData, list } = toRefs(props);
    const disabled = computed(() => options.value.power == 1);
    const fileList = computed<UfUploadFileType[]>({
      get() {
        return modelValue.value;
      },
      set(value) {
        emit("update:modelValue", value);
      }
    });

    const onlyHeader = ref(false);
    watch(
      () => formData,
      data => {
        const idCard = list.value?.find(i => i.field === "id_card_type");

        if (idCard && data.value) {
          const idCardType = data.value[idCard.id];
          onlyHeader.value = idCardType == 2; //只有护照的时候证件照片仅显示一张照片
        }
      },
      {
        deep: true
      }
    );
    return {
      fileList,
      disabled,
      onlyHeader
    };
  }
});
